var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoiconDsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 24,
    viewBox: "0 0 81 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#192862",
    fillRule: "evenodd",
    d: "M70.537 22.559C70.272 23.074 69.493 24 68.14 24h-5.557c-1.344 0-2.139-.937-2.378-1.428l-7.525-15.33c-.738-1.444-2.288-1.908-3.583-1.908H35.434c-1.26 0-1.995.81-1.995 2 0 1.266.82 2 2.014 2h9.4c4.003 0 7.316 2.427 7.316 7.333 0 4.936-3.345 7.332-7.316 7.332H32.772c-1.096 0-2.007-.637-2.007-2.023v-2.641c0-.449.3-.668.67-.668h10.744c1.114 0 2.007-.671 2.007-2 0-1.314-.877-2.002-2.004-2.002l-10.106.002c-1.694 0-3.232-.464-4.32-1.18-.558 6.504-5.196 10.512-11.973 10.512H.668c-.37 0-.668-.222-.668-.667V10.001c0-.443.294-.665.657-.667h5.32c1.419 0 2.049.911 2.049 1.99V18h.004c0 .443.294.663.656.666h4.616c3.63 0 6.65-2.204 6.65-6.665 0-4.469-3.007-6.666-6.65-6.666H.652C.292 5.328 0 5.11 0 4.666V2.02C0 .524 1.055 0 2.026 0L15.851 0c3.892 0 7.412 1.445 9.484 4.109C26.46 1.399 28.977 0 32.137 0h19.8c2.433 0 5.186.837 6.618 3.652l6.407 13.474c.066.138.196.203.359.203.149 0 .288-.055.356-.196 0 0 7.923-16.714 7.97-16.81.04-.09.204-.323.59-.323h6.093c.371 0 .67.22.67.666a.78.78 0 0 1-.066.326L70.537 22.559z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoiconDsv);
export default __webpack_public_path__ + "static/media/logoicon-dsv.e316f1396f3b894d4b250ca29a7ad47b.svg";
export { ForwardRef as ReactComponent };